import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { Chats, Status } from 'src/app/interfaces/chatData';
import { ChatsService } from 'src/app/service/chats.service';
import { LoginService } from 'src/app/service/login.service';
import { MessageData } from 'src/app/service/messageData';
import { MessagesService } from 'src/app/service/messages.service';
@Component({
  selector: 'app-panelcompchat',
  templateUrl: './panelcompchat.component.html',
  styleUrls: ['./panelcompchat.component.scss'],
  providers: [MessageService]
})
export class PanelcompchatComponent implements OnInit, OnDestroy {
  activeTab: number = 0
  chats: Chats[] = [];
  messages: MessageData[] = []
  rolUsuario: number | undefined
  conversations!: any[];
  idSuscription!: number;
  idStatus!: number | null;
  idStatusChange!: number | null;
  newConversation: boolean = false;
  countMessages!: number
  nuevosChats!: Chats[]
  isNewChat? : boolean = false
  @Input() pagina!: number

  estatus: Status[] = [];
  private palabraBuscar: string = "";
  private suscripciones: Subscription = new Subscription();

  constructor(private chatsService: ChatsService, private messageService: MessagesService,
    private loginService: LoginService, private messagesAlerta: MessageService,
    private route: ActivatedRoute, private translate: TranslateService) {
      this.rolUsuario = loginService.chatCrmUser.idRol;
      this.suscripciones.add(
        messageService.searchTerm$.subscribe(term =>{
          if(term == "" && this.palabraBuscar != '' && this.activeTab != 0){
            this.activeTab = 0;
  
          }
          this.palabraBuscar = term;
        })
      )
      // Establecer idiomas disponibles y el idioma por defecto
      translate.addLangs(['en', 'es']);
      translate.setDefaultLang('es');
  }

  ngOnDestroy(): void {
    this.suscripciones.unsubscribe();
  }

  ngOnInit(): void {
    this.chatsService.obtenerStatus(this.loginService.chatCrmUser.idCustomer).then(data => this.estatus = data.data);
    this.suscripciones.add(
      this.messageService.dispositivo$().subscribe((device) => {
        if (device) {
          this.idSuscription = device.id
          this.rolUsuario = this.loginService.chatCrmUser.idRol;
          this.getConversations();
        }
      })
    );
    this.suscripciones.add(
      this.messageService.obtenerStatus().subscribe(value => {
        this.idStatus = value;
        console.log('idstatus', this.idStatus)
        this.rolUsuario = this.loginService.chatCrmUser.idRol;
        this.getConversations();
    
        // Encuentra el índice correspondiente al idStatus en el arreglo de estatus
        const index = this.estatus.findIndex(status => status.idStatus == this.idStatus);
        console.log('index encontrado', index)
        // Establece activeTab con el índice correspondiente o un valor por defecto (0 si no hay coincidencia)
        this.activeTab =  index + 1
        console.log('activetab', this.activeTab) // +1 porque el primer p-tabPanel es el de "Todos"
      })
    );
    this.suscripciones.add(
      this.messageService.obtenerChats().subscribe((nuevosChats) => {
        let hayChatsAsignados = false;
        if(nuevosChats.length == 0){
          return;
        }
        if (this.idStatus != undefined && this.idStatus != null && this.idStatus != 0) {
          const nuevosChatsFiltro = nuevosChats.find(c => c.idStatus === this.idStatus && c.newConversation);
          if (nuevosChatsFiltro != undefined && nuevosChatsFiltro != null) {
            const chatsActuales = this.chats;
            Array.from(nuevosChats).forEach(c => {
              const index = chatsActuales.findIndex(chat => chat.chatId === c.chatId);
              if (index !== -1) {
                this.chats[index] = c;
              }
            });
          }
        }else{
          this.chats = nuevosChats;
        }
        this.chats.map(value => {
          const newChatAsigned = value.newChatAsigned
          if (newChatAsigned === true) {
            hayChatsAsignados = true

            if (hayChatsAsignados) {
              this.messagesAlerta.add({ severity: 'success', summary: this.translate.instant('PANELCOMPCHAT_NEW_CHATS_SUMMARY'), detail: this.translate.instant('PANELCOMPCHAT_NEW_CHATS') });
            }
          }
        })
      })
    );
    this.suscripciones.add(
      this.messageService.obtenerIdStatus().subscribe((id) => {
        this.idStatus= id;
      })
    );
    this.suscripciones.add(
      this.chatsService.nombresActualizados$.subscribe(data => {
        this.chats?.map(value =>{
          if(value.chatId === data?.chatId)
          value.name = data?.nuevoNombre
        })
      })
    );
    this.chats = []
    // Obtener el parámetro 'lang' de la URL
    this.route.queryParams.subscribe(params => {
      const lang = params['lang'];
      if (lang) {
        this.translate.use(lang);
      } else {
        this.translate.use('es'); // Idioma por defecto
      }
    });
  }

  actualizarNombreEnChats(chatId: string, nuevoNombre: string) {
    const chatActualizado = this.chats.find(chat => chat.chatId === chatId);
    if (chatActualizado) {
      chatActualizado.name = nuevoNombre;
    }
  }
  
  estatusSelected!: number;
  handleChange(index: any): void {
    let idStatusToSend: number = 0;
    if (index !== 0) {
      const estatusSeleccionado = this.estatus[index - 1]; 
      if (estatusSeleccionado) {
        idStatusToSend = estatusSeleccionado.idStatus;
      }
      this.estatusSelected = idStatusToSend
      console.log('estatus seleccionado', estatusSeleccionado)
  }
  this.messageService.establecerEstatus(idStatusToSend);
  this.messageService.setSelectedChat(null);
  this.messageService.infoContacto(null);
  if(index !== 0){
    this.messageService.updateSearchTerm('');
  }
}
  
  private async getConversations(): Promise<void> {
    if(!this.idSuscription){
      this.messagesAlerta.add({ severity: 'error', summary: 'Error', detail: this.translate.instant('PANELCOMPCHAT_ERROR_SELECT_DEVICE') });
      return;
    }
    if (this.rolUsuario === 1 || this.rolUsuario === 2) {
      const response = await this.messageService.getConversations(this.idSuscription, this.idStatus);
      this.chats = response.data.result;
      this.messageService.setChats(this.chats)
    } else {
      const idUser = this.loginService.chatCrmUser.id;
      const response = await this.messageService.getConversations(this.idSuscription, this.idStatus, idUser);
      this.chats = response.data.result;
      this.messageService.setChats(this.chats)
    }

    if(this.chats.length == 0){
      this.messagesAlerta.add({ severity: 'info', summary: this.translate.instant('PANELCOMPCHAT_NO_MESSAGES_SUMMARY'), detail: this.translate.instant('PANELCOMPCHAT_NO_MESSAGES') });
    }
    for (const objeto of this.chats) {
      if (objeto.newConversation === true) {
      //  this.newConversation = true;
        // this.countMessages = objeto.countMessages;
        
        this.messagesAlerta.add({ severity: 'success', summary: this.translate.instant('PANELCOMPCHAT_NEW_MESSAGES_SUMMARY'), detail: this.translate.instant('PANELCOMPCHAT_NEW_MESSAGES') });
        // if (objeto.countMessages === 0) {
        //   objeto.countMessages = 1;
        // }
        
        break; // Detiene el bucle una vez que se encuentra la primera newConversation
      }
    }
    // let hayNuevaConversacion = false
    // if(this.newConversation === true){
    //   hayNuevaConversacion = true
    // }
  
    this.messageService.updateIdStatus(this.idStatus);
  }
  
}
